<!-- eslint-disable -->

<script setup>
import { useMenuStore } from '@/stores/menus';
import { useFooterSectionStore } from '@/stores/footer_sections';
import { computed, ref, onMounted, onUnmounted } from 'vue';
import Social from './footer_sections/Social.vue';
import Payments from './footer_sections/Payments.vue';
import Regulation from './footer_sections/Regulation.vue';
import RegulationMobile from './footer_sections/RegulationMobile.vue';
import { useInitializeStore } from '@/stores/initialize';

import Contact from './footer_sections/Contact.vue';
import Description from './footer_sections/Description.vue';
import Livechat from './footer_sections/Livechat.vue';
import LanguageSelector from './footer_sections/LanguageSelector.vue';


const menuStore = useMenuStore();
const initializeStore = useInitializeStore();
const footerSectionStore = useFooterSectionStore();
const is_chat_enabled = process.env.VUE_APP_CHAT_ENABLED == 'true';
const isMobileView = ref(false);

const checkScreenSize = () => {
	isMobileView.value = initializeStore.screenWidth <= 767;
};

onMounted(() => {
	checkScreenSize();
	window.addEventListener('resize', checkScreenSize);
});

onUnmounted(() => {
	window.removeEventListener('resize', checkScreenSize);
});

const getUrl = (menu_child) => {
	if (menu_child.click_url == '#/pre-sports' || menu_child.click_url == '/pre-sports') {
		return '/pre-sports/coupons';
	}
	if (!menu_child.click_url && !menu_child.static_page_url) return false
	if (menu_child.click_url == '#/promotions/all') return menu_child.click_url.replace('#', '').replace('/all', '');
	if (menu_child.click_url) return menu_child.click_url.replace('#', '');
	else if (menu_child.static_page_url) return menu_child.static_page_url;
}

const showSocialLanguageLivechatSection = computed(() => {
	if (footerSectionStore.getSocialSection || footerSectionStore.getLivechatSection || footerSectionStore.getLanguageSelectorSection) return true;
	else return false;
});

const showDescriptionRegulationContactSection = computed(() => {
	if (footerSectionStore.getDescriptionSection || footerSectionStore.getRegulationSection || footerSectionStore.getContactSection) return true;
	else return false;
});

const showPaymentsSection = computed(() => {
	if (footerSectionStore.getPaymentSection) return true;
	else return false;
});

const showDescriptionRegulationSection = computed(() => {
	if (footerSectionStore.getDescriptionSection || footerSectionStore.getRegulationSection) return true;
	else return false;
});

const showContactSection = computed(() => {
	if (footerSectionStore.getContactSection) return true;
	else return false;
});

const is_half_width = computed(() => {
	const has_description = footerSectionStore.getDescriptionSection;
	const has_contact_or_regulation = footerSectionStore.getContactSection || footerSectionStore.getRegulationSection;

	return has_description && has_contact_or_regulation;
});

</script>
<template>
	<footer>
		<div class="container-lg">
			<div class="footer-desktop" v-if="!isMobileView">
				<div class="footer-social-regulation" v-if="showSocialLanguageLivechatSection">
					<Social> </Social>
					<div class="livechat-language">
						<Livechat> </Livechat>
						<LanguageSelector> </LanguageSelector>
					</div>
				</div>
				<div class="footer-outer">
					<template v-if="menuStore.getFooterMenus">
						<div class="footer-inner" v-for="menu in menuStore.getFooterMenus" :key="menu">
							<h6>{{ menu.name }}</h6>
							<div class="footer-menu ">
								<ul>
									<template v-for="menu_child in menu.children" :key="menu_child">
										<li v-if="menu_child.click_url == '/live-chat'" >
											<a v-if="is_chat_enabled" href="javascript:void(0);" onclick="zE.activate({hideOnClose: true});">{{ menu_child.name }}</a>
											<a v-else href="javascript:void(0);">{{ menu_child.name }}</a>
										</li>
										<li v-else>
											<a v-if="getUrl(menu_child)" :href="getUrl(menu_child)">{{ menu_child.name }}</a>
										</li>
									</template>
								</ul>
							</div>
						</div>
					</template>
				</div>
				<div class="footer-descr-contact" v-if="showDescriptionRegulationContactSection">
					<div class="desc-section" :class="{ 'half-width': is_half_width }">
						<Description></Description>
					</div>
					<div class="footer-contact-section">
						<Regulation> </Regulation>
						<Contact></Contact>
					</div>
				</div>
				<div class="footer-payments-section" v-if="showPaymentsSection">
					<Payments></Payments>
				</div>
			</div>

			<div class="footer-mobile" v-else> <div class="footer-social-regulation" v-if="showSocialLanguageLivechatSection">
					<template v-if="footerSectionStore.getLanguageSelectorSection">
						<Social> </Social>
						<div class="livechat-language">
							<Livechat> </Livechat>
							<LanguageSelector> </LanguageSelector>
						</div>
					</template>
					<template v-else>
						<div class="social-language">
							<Livechat> </Livechat>
							<Social> </Social>
						</div>
					</template>
				</div>
				<div class="mobile-descr-contact" v-if="showContactSection">
					<div class="contact-section">
						<Contact></Contact>
					</div>
				</div>
				<div class="footer-outer">
					<template v-if="menuStore.getFooterMenus">
						<div class="footer-inner" v-for="menu in menuStore.getFooterMenus" :key="menu">
							<h6>{{ menu.name }}</h6>
							<div class="footer-menu ">
								<ul>
									<template v-for="menu_child in menu.children" :key="menu_child">
										<li v-if="menu_child.click_url == '/live-chat'" >
											<a v-if="is_chat_enabled" href="javascript:void(0);" onclick="zE.activate({hideOnClose: true});">{{ menu_child.name }}</a>
											<a v-else href="javascript:void(0);">{{ menu_child.name }}</a>
										</li>
										<li v-else>
											<a v-if="getUrl(menu_child)" :href="getUrl(menu_child)">{{ menu_child.name }}</a>
										</li>
									</template>
								</ul>
							</div>
						</div>
					</template>
				</div>
				<div class="mobile-description" v-if="showDescriptionRegulationSection">
					<div class="desc-section">
						<Regulation style="margin-top: 8px; margin-bottom:8px"> </Regulation>
						<Description></Description>
					</div>
				</div>
				<div class="mobile-payments" v-if="showPaymentsSection">
					<Payments></Payments>
				</div>
			</div>
		</div>
	</footer>
</template>
<style scoped>
@media (min-width: 768px) {
	.desc-section.half-width {
		width: 50%;
	}
}

.livechat-language {
	display: flex;
	align-items: center;
	gap: 11px;
}
footer .footer-outer{
	padding-top: 30px;
}
.footer-descr-contact {
	display: flex;
	gap: 10px;
	border-bottom: 1px solid var(--tab-gray);
	padding: 20px 0px;
	justify-content: space-between;
	align-items: center;
}

/* .footer-desktop {
	display: none;
}

.footer-mobile {
	display: none;
} */

.footer-social-regulation {
	display: flex;
	gap: 10px;
	border-bottom: 1px solid var(--tab-gray);
	padding: 0px 0px 20px 0px;
	justify-content: space-between;
	align-items: center;
}

.footer-descr-contact {
	grid-template-columns: 48% 48%;
	border-bottom: 1px solid var(--tab-gray);
	padding: 20px 0px;
}

.footer-payments-section {
	padding: 20px 0px;
}

.mobile-descr-contact {
	padding: 20px 0px;
	border-bottom: 1px solid var(--tab-gray);
}

.mobile-payments {
	padding: 20px 0px 40px 0px;
	border-bottom: 1px solid var(--tab-gray);
}

.mobile-description {
	padding: 20px 0px;
}

/* @media screen and (max-width: 767px) {
	.footer-mobile {
		display: block;
	}
} */
@media screen and (max-width: 510px) {
	.footer-social-regulation {
		display: flex;
		border-bottom: 1px solid var(--tab-gray);
		padding: 0px 0px 20px 0px;
		flex-direction: column;
	}
	.livechat-language{
		width: 100%;
		justify-content: space-between;
	}

	.social-language {
		display: flex;
		justify-content: space-between;
		width: 100%;
	}
}

/* @media screen and (min-width: 768px) {
	.footer-desktop {
		display: block;
	}
} */
</style>
